export default "__VITE_ASSET__CVgnCF6C__"